import React from 'react';

function ManuscriptTemplate() {
  return (
    <div className="container py-5">
      <h2 className="mb-4 text-center fw-bold">Manuscript Template</h2>
      <p>All submissions must use the official manuscript template. This ensures consistency and speeds up the review process.</p>
      <div className="alert alert-info">Download the template: <a href="#">Manuscript_Template.docx</a> (coming soon)</div>
      <h4 className="mt-4">Instructions for Use</h4>
      <ul>
        <li>Fill in all required sections: Title, Abstract, Keywords, Main Text, References.</li>
        <li>Do not alter the formatting or styles.</li>
        <li>Save your file as .docx or PDF before submission.</li>
      </ul>
    </div>
  );
}

export default ManuscriptTemplate; 